import ApiService from '@/core/services/api.service';

export const TechnicalErrorService = {
  getAll(params = {}) {
    return ApiService.query(`v1/warranty/technical-errors`, { params });
  },

  getById(id) {
    return ApiService.get(`v1/warranty/technical-errors/${id}`);
  },

  create(data) {
    return ApiService.post('v1/warranty/technical-errors', data);
  },

  update(id, data) {
    return ApiService.put(`v1/warranty/technical-errors/${id}`, data);
  },

  delete(id) {
    return ApiService.delete(`v1/warranty/technical-errors/${id}`);
  },

  updateActiveStatus(id, isActive) {
    return ApiService.patch(
      `v1/warranty/technical-errors/${id}/active-status`,
      {
        isActive,
      },
    );
  },

  getByErrorGroupId(errorGroupId) {
    return ApiService.get(
      `v1/warranty/error-groups/${errorGroupId}/technical-errors`,
    );
  },

  getErrorGroups() {
    return ApiService.get(`v1/warranty/error-groups`, {
      params: {
        isActive: true,
        limit: 100,
      },
    });
  },
};
